import { CHANGE_VISIBLE_COMPETITORS } from "../constants";

export const changeVisibleCompetitors = (flag) => ({
  type: CHANGE_VISIBLE_COMPETITORS,
  payload: flag,
});
